export default __webpack_public_path__ + "static/media/rnr-sports-table-15.6cc45b74.webp";